import { ENV } from '../../config/runtimeEnv';
import axios from "axios";
import { AiPanelData } from "../../types/geneCodes/AiPanelDataTypes";
import { sessionLabiqUserId } from "../../utils/auth/labiqUserId";
import { http } from "../../lib/http/client";
const API_BASE_URL = ENV.VITE_LABIQ_SERVER;


export const getAiPanelDataForSample = async (sampleId: string, panelId: number): Promise<AiPanelData> => {
	try {
		const response = await http.get(
			`${API_BASE_URL}/panels/aiData/${sampleId}`,
			
			{
				params:{
				panel_id: panelId,
			}
			}
		);
		return response.data;
	} catch (error) {
		throw new Error(`Error creating application: ${error}`);
	}
};

/** 200 body of POST /panels/aiData. The job is QUEUED at this point, never finished. */
export interface GeneratePanelDataResponse {
	message: string;
	sample_id: string;
	panels_count: number;
	panels: string[];
}

/** Carries the status alongside the server's message — 403, 503 and 400 each mean something different. */
export class PanelGenerationError extends Error {
	readonly status?: number;

	constructor(message: string, status?: number) {
		super(message);
		this.name = "PanelGenerationError";
		this.status = status;
	}
}

/**
 * Queues AI analysis for EVERY panel on the sample; `force` overwrites panels that already have a
 * report and is admin-only server side. Returns as soon as the job is dispatched.
 */
export const generatePanelData = async (sampleId: string, force = false): Promise<GeneratePanelDataResponse> => {
	try {
		const response = await http.post(
			`${API_BASE_URL}/panels/aiData`,
			{
				sample_id: sampleId,
				user_id: sessionLabiqUserId(),
				force,
			}
		);
		return response.data;
	} catch (error) {
		if (axios.isAxiosError(error)) {
			throw new PanelGenerationError(error.response?.data?.message ?? error.message, error.response?.status);
		}
		throw new PanelGenerationError("Could not start the AI panel analysis");
	}
};
